"use client"

import Heading2 from "@/components/text/Heading2"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@relume_io/relume-ui"
import { useMemo } from "react"

const faqData = [
  {
    question: "Wat is GoodShift",
    answer:
      "GoodShift is het innovatieve donatieplatform waar je gemakkelijk en flexibel kunt doneren aan al jouw favoriete goede doelen. Van een klein gebaar naar een grote impact",
  },
  {
    question: "Kan ik met een goed gevoel doneren?",
    answer: (
      <>
        <p>Ja, dat kan zeker:</p>
        <ul className="list-disc pl-4">
          <li>
            GoodShift is een stichting en volledig non-profit. 100% van je donatie gaat naar het goede doel, zonder
            verborgen kosten. Dit geldt ook voor acties via GoodShift.
          </li>
          <li>GoodShift is een CBF Erkend donatieplatform.</li>
          <li>Betalingen worden veilig afgehandeld via het betaalplatform Mollie.</li>
          <li>Jouw gegevens worden zonder toestemming niet met derden gedeeld.</li>
        </ul>
      </>
    ),
  },
  {
    question: "Hoe kan ik mijn donatie stopzetten?",
    answer: (
      <>
        <p>Je kunt je donatie eenvoudig wijzigen in de app: </p>
        <ol className="list-disc pl-4">
          <li>Ga naar &apos;donaties&apos; in het menu van de app.</li>
          <li>Klik op de betreffende donatie.</li>
          <li>
            Gebruik de &apos;edit&apos; functie (pen-icoontje) om de donatie per direct te starten, stoppen, wijzigen of
            pauzeren.
          </li>
          <li>Jouw gegevens worden zonder toestemming niet met derden gedeeld.</li>
        </ol>
      </>
    ),
  },
  {
    question: "Moet ik een incassomachtigiging afgeven?",
    answer:
      "Voor maandelijkse donaties is een incassomachtiging nodig. Dit kun je eenvoudig beheren in je persoonlijke account. Bij je eerste donatie geef je toestemming via iDeal. Daarna worden donaties automatisch uitgevoerd. Eenmalige donaties hebben geen incassomachtiging nodig.Je kunt er wel voor kiezen een machtiging af te geven voor ‘doneren met één klik’.Hierdoor kun je het iDeal proces overslaan elke keer dat je geeft.",
  },
  {
    question: "Wat zijn 'Bundel' donaties?",
    answer:
      "Met de bundels van GoodShift steun je met één donatie meerdere goede doelen binnen een specifiek thema. Of je nu maandelijks of eenmalig doneert, met onze bundels maken we het gemakkelijk om een keuze te maken, en blijf je op de hoogte van de impact van jouw donatie(s).",
  },
  {
    question: "Wat zijn goodshift giftcards?",
    answer:
      "Met de GoodShift giftcards kunnen organisaties samen met werknemers, klanten of leden op een transparante en eenvoudige manier een maatschappelijke bijdrage leveren. Via onze app is het mogelijk om de giftcard te verzilveren. Vervolgens is het donatiebedrag via de GoodShift app in te zetten voor een eenmalige donatie aan één goed doel. Voor vragen over het gebruik of over de aanschaf van de GoodShift giftcards kun je contact opnemen via hello@goodshift.nl.",
  },
  {
    question: "Hoe werkt het gebruik van de Goodshift giftcard?",
    answer: (
      <>
        <p>Volg na het downloaden van de app en een eenmalige registratie de volgende stappen:</p>
        <ul className="list-disc pl-4">
          <li>Ga naar de pagina van het goede dol ewat je wilt steunen</li>
          <li>Klik op &quot;Geef&quot; en selecteer &quot;Gebruik mijn Donatie giftcard&quot;</li>
          <li>Controleer en bevestig de donatie. Zo eenvoudig is het!</li>
        </ul>
      </>
    ),
  },
  {
    question: "Kan ik het bedrag van een giftcard splitsen tussen twee goede doelen?",
    answer:
      "Nee, het is nu nog niet mogelijk het bedrag te splitsen. Je kunt met de GoodShift giftcard eenmalig één goed doel steunen.",
  },
  {
    question: "Waarom Goodshift?",
    answer: (
      <>
        <p>Doneren via GoodShift:</p>
        <ul className="list-disc pl-4">
          <li>
            <strong>Flexibel:</strong> Start, stop, pauzeer en wijzig wanneer jij dat wilt.
          </li>
          <li>
            <strong>Gemak:</strong> Een eenvoudige app die overzichtelijk is.
          </li>
          <li>
            <strong>Ruim aanbod:</strong> 200+ erkende goede doelen om aan te geven.
          </li>
          <li>
            <strong>Van en voor jou:</strong> Een persoonlijk account dat geven makkelijk en leuk maakt.
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Kan ik ook eenmalige donaties doen?",
    answer:
      "Ja, in de app kun je eenvoudig een eenmalige donatie doen. Je kunt er ook voor kiezen om maandelijks te doneren. Ook dit regel je eenvoudig met één klik.",
  },
  {
    question: "Kan ik een donatie ook laten terugstorten als ik me bedenk?",
    answer:
      "Ja, je kunt een donatie laten terugstorten. Neem binnen 4 weken contact met ons op via XXX en wij regelen het voor je.",
  },
  {
    question: "Waarom zie ik mijn bankrekeningnummer niet in de app?",
    answer:
      "GoodShift slaat uit privacyoverwegingen geen bankrekeningnummers op. Betalingen en machtigingen lopen via het betaalplatform Mollie.",
  },
  {
    question: "Kan ik anoniem doneren?",
    answer:
      "Ja, je kunt anoniem doneren. We vragen alleen je e- mailadres voor registratie en zorgen ervoor dat je gegevens niet met derden worden gedeeld.Voor meer informatie kun je onze privacy policy raadplegen.",
  },
  {
    question: "Waar kan ik de giftcards kopen?",
    answer:
      "Voor vragen over de aanschaf van de GoodShift giftcards voor organisaties, kun je contact opnemen via hello@goodshift.nl.Binnenkort is het ook mogelijk voor particulieren om giftcards te bestellen. Stuur ons een e-mail als je een bericht wilt ontvangen wanneer dat mogelijk is.",
  },
  {
    question: "Welke goede doelen zitten er in de app?",
    answer:
      "Alle goede doelen met een CBF-keurmerk of ANBI-status kunnen zich aansluiten bij GoodShift. We richten ons niet alleen op grote organisaties, maar ook op kleine lokale initiatieven. Lees meer over onze procedure voor onboarding van goede doelen. Wij zijn continu bezig met het uitbreiden van ons aanbod aan goede doelen. Heb jij een suggestie voor een nieuw goed doel? Geef het door via Whatsapp of stuur een e-mail naar hello@goodshift.nl.",
  },
  {
    question: "Wat betalen goede doelen aan GoodShift?",
    answer:
      "Goede doelen kunnen zich gratis aanmelden en zijn via de zoekfunctie in de app te vinden. Voor extra zichtbaarheid (bijvoorbeeld via thema's of themabundels) vragen wij vanaf 2025 een bijdrage om de kosten van de stichting te dekken.",
  },
  {
    question: "Hoe kan het dat de app gratis is én 100% van elke donatie naar het goede doel gaat?",
    answer:
      "GoodShift is een stichting zonder winstoogmerk. Wij vinden het belangrijk dat alle donaties volledig bij de goede doelen terechtkomen. GoodShift is zelf ook een goed doel en ontvangt daarom donaties. Ook zijn er een aantal grote funders die het initiatief van GoodShift een warm hart toedragen en graag een maatschappelijke bijdrage leveren. Daarnaast kunnen goede doelen een communicatie-abonnement afnemen op het donatieplatform. We houden de kosten laag door te werken met een klein team van betrokken ondernemers, die veelal op vrijwillige basis hun expertise voor GoodShift inzetten en het bestuur geen salaris ontvangt.",
  },
  {
    question: "Zijn donaties via GoodShift aftrekbaar van de belasting?",
    answer:
      "Ja, GoodShift is door de belastingdienst erkend als donatieplatform voor ANBI-doelen. Dit betekent dat donaties aan ANBI-doelen via GoodShift hun ANBI-status behouden en belastingvoordeel opleveren.",
  },
  {
    question: "Heeft GoodShift een klachtenprocedure?",
    answer: "We hopen natuurlijk dat niemand het nodig heeft maar onze klachtenprocedure is hier te lezen.",
  },
]

const Faq: React.FC = () => {
  const midIndex = useMemo(() => Math.ceil(faqData.length / 2), [])
  // Split the faqData into two columns for better layout
  const columns = useMemo(() => [faqData.slice(0, midIndex), faqData.slice(midIndex)], [midIndex])

  return (
    <div className="container">
      <div className="mx-auto mb-12 w-full max-w-lg md:text-center md:mb-18 lg:mb-20">
        <Heading2>Vragen die we vaker horen</Heading2>
      </div>
      <div className="grid w-full auto-rows-min grid-cols-1 items-start gap-x-12 md:grid-cols-2 lg:gap-x-16">
        {columns.map((column, columnIndex) => (
          <Accordion key={columnIndex} type="multiple" className="w-full AccordionChevron">
            {column.map((item, index) => (
              <AccordionItem
                key={`item-faq_accordion-${columnIndex}-${index}`}
                value={`item-faq_accordion-${columnIndex}-${index}`}
                className="first:border-t border-b border-black overflow-hidden">
                <AccordionTrigger className="py-5 text-[1.125rem] text-left font-bold AccordionTrigger">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="md:pb-6 text-[1rem] pb-[1rem]">
                  {typeof item.answer === "string" ? <p>{item.answer}</p> : item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        ))}
      </div>
    </div>
  )
}
export default Faq
